import React, { Component } from "react";
import "./styles.css";
import G from "../../../js/globals";
import E from "../../../js/events";
import RadioToggle from "../../widgets/radio-toggle/view";

import FloatingArrows from "../../widgets/floating-arrows/view";





class SectionEventType extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.handleEventTypeSlideChange = this.handleEventTypeSlideChange.bind(this);
    this.handlePopupClick = this.handlePopupClick.bind(this);

  }



  // ===============================================================================================
  // Changes to the selected slide
  handleEventTypeSlideChange = (selectedIndex) => {
    // console.log("EVENT TYPE SLIDE CHANGE REQUESTED:", this.props);
    if (this.props.eventType === "hosted") {
      // selectedIndex = 1;
    } else if (this.props.eventType === "no-host") {
      // selectedIndex = 1;
    }
    // console.log(`Moving to ${selectedIndex} (${this.props.items[selectedIndex].id})`);
    this.props.handleChange(selectedIndex);
    // this.carousel.slideTo(selectedIndex);
  }


  // ===============================================================================================
  handleEventTypeChange = (value) => {
    // console.log("EVENT TYPE:", value);
    this.props.handleAppEvent(E.events.EVENTTYPE_MOD_TYPE, value);
  }

  handlePopupClick = (value) => {

    let popupHeading = "";
    let popupMessage = "";

    if (value === "no-host") {
      popupHeading = "Book an Event Space";
      popupMessage = (
        <div>
          <p>The hire of a room or space within a McDonald's Restaurant.</p>
          <p>This includes:</p>
          <ul>
            <li>90 minute room/space hire. Set-up and Pack-down completed by the customer is included in this time. </li>
            <li>Ability to add-on items (per piece) such as ice cream cakes, invitations, bunting, colouring packs, party hats, party bags and surprise birthday gifts.</li>
          </ul>
        </div>
      );
    } else if (value === "hosted") {
      popupHeading = "Celebrate with 'The Classic Party Package'";
      popupMessage = (
        <div>
          <p>Our classic package comes with all McDonald's Parties.</p>
          <p>Package includes:</p>
          <ul>
            <li>Personal Party Host</li>
            <li>90 minutes of fun and games</li>
            <li>Happy Meal® menu selection including Happy Meal Toy, per child*</li>
            <li>Happy Celebration Pack/Party Bag, per child</li>
            <li>Invitations and a Birthday Card, per child</li>
            <li>Hats, tray mats and crayons, per child</li>
            <li>Gift for birthday child</li>
          </ul>
          <div className="disclaimer">*Price per child based on the standard party menu and additional charges may apply depending on choice of restaurant or any additions/variations made to the party package. Extra Charges apply for 6pc Chicken McNuggets® Happy Meal. Final amount will be confirmed at the end of the party. For allergen information, please visit the nutrition section of our website.</div>
        </div>
      );
    }

    let newInfoPopup = G.popups.newPopup()
      .heading(popupHeading)
      .message(popupMessage)
    this.props.handleAppPopup(newInfoPopup);
  }

  render() {

    // ---------------------------------------------------------------------------------------------
    return (
      <div className="cont-section cont-section--offset-header cont-section--eventType">
        <div className="cont-wrapper">

          <div className="birthdays">
            <div className="title-smile">
              <img className="title-smile-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/smile.svg"  alt="smile"/>
            </div>
            <div className="birthdays__title bold-text">
              <img className="title-img" src="https://mcdonalds.com.au/sites/mcdonalds.com.au/files/lets-celebrate.svg"  alt="Let's celebrate"/>
            </div>

            <div className="birthdays__hint">
              Select your event type
            </div>

            <RadioToggle
              eventType={this.props.eventType}
              handleChange={this.handleEventTypeChange}
              handleInfoPopup={this.handlePopupClick}
            />

          </div>

          <FloatingArrows
            handleChange={   this.handleEventTypeSlideChange                                     }
            items={          this.props.items                                                    }
            hidden={         (this.props.activeSlideId !== 'intro' && this.props.activeSlideId !== 'eventType') ? true : false }
            activeSlide={    this.props.activeSlide                                               }
          />

        </div>
      </div>
    );
  }

}

export default SectionEventType
